<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in comList"
        :label="item.title"
        :name="item.value"
        :key="item.value"
      >
        <ComList :list-type="item.value" :ref="'ComList' + item.value" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ComList from "@/views/outOfDomestic/domesticShipment/returnGoods/components/ComTable";

export default {
  title: "退货件",
  name: "returnGoods", // 退货件
  components: {
    ComList,
  },
  data() {
    return {
      activeName: "0",
      dataSource: [],
      comList: [
        { title: "待处理", value: "0" },
        { title: "处理中", value: "1" },
        { title: "已发货", value: "2" },
        { title: "无法退货", value: "3" },
      ],
    };
  },
  mounted(){
      this.$refs['ComList0'][0].getDomesticList(true);
  },
  methods: {
    handleClick(res) {
      let index = res.index;
      let refname = "ComList" + index;
      this.$refs[refname][0].getDomesticList(true);
    },
  },
};
</script>

<style scoped></style>
